
import { getCertificateProvenance } from 'store/certificates/actions'
import type { GetCertificateProvenancePayload, ProvenanceResponseData } from 'store/certificates/types'
import { useSelector } from 'store/hooks'

import type { UseQuerySelectOptions, UseQuerySelectResult } from 'hooks'

import { useQuerySelect } from 'hooks'


type UseCertificateProvenanceParams = GetCertificateProvenancePayload

type UseCertificateProvenanceResult = {
  data: ProvenanceResponseData | null
} & UseQuerySelectResult<UseCertificateProvenanceParams>

export const useCertificateProvenance = (
  params: UseCertificateProvenanceParams,
  options?: UseQuerySelectOptions
): UseCertificateProvenanceResult => {
  const result = useQuerySelect(getCertificateProvenance, params, options)
  const data = useSelector(state => state.certificates.certificateProvenance)

  return {
    data,
    ...result,
  }
}
